import React from 'react';

export const HomePage: React.FC = () => (
  <h1 className="title">Home Page</h1>
);
